import EfSpec from '@elem/ui/ef-spec';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('Oasis');
    const items: string[] = [t('C_box2_tip')];
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');

    return (
        <div className={`${css.section}`}>
            <EfSpec className="s" />
            {IS_NA_SITES && (
                <ul className="items">
                    {items.map((item: string, k: number) => (
                        <li className="item" key={k}>
                            {item}
                        </li>
                    ))}
                </ul>
            )}
            <EfSpec />
        </div>
    );
}
